/**
 * Documentation KFP API
 * ## Common Request Headers - Authorization (string `Bearer {AccessToken}`, if signed-in) - After the client has successfully obtained `AccessToken` via Login, it\'s sent in every request as a bearer token.
 *
 * The version of the OpenAPI document: 1
 * Contact: novak@techcrowd.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { BaseFilter } from '../model/models';
import { ChangeNewStatusRequest } from '../model/models';
import { CreateNewsRequest } from '../model/models';
import { NewsResource } from '../model/models';
import { UpdateNewsRequest } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface NewsServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Change news status
     * 
     * @param id 
     * @param changeNewStatusRequest 
     */
    changeNewStatus(id: string, changeNewStatusRequest?: ChangeNewStatusRequest, extraHttpRequestParams?: any): Observable<NewsResource>;

    /**
     * Saves New to database
     * 
     * @param createNewsRequest 
     */
    createNews(createNewsRequest?: CreateNewsRequest, extraHttpRequestParams?: any): Observable<NewsResource>;

    /**
     * Deletes new with given by ID
     * 
     * @param id 
     */
    deleteNews(id: string, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Find new by given ID
     * 
     * @param id 
     */
    getNewById(id: string, extraHttpRequestParams?: any): Observable<NewsResource>;

    /**
     * Get list of news
     * 
     * @param filter Get news by filter
     */
    getNewsLists(filter?: BaseFilter, extraHttpRequestParams?: any): Observable<Array<NewsResource>>;

    /**
     * Updates an existing news
     * 
     * @param id 
     * @param updateNewsRequest 
     */
    updateNews(id: string, updateNewsRequest?: UpdateNewsRequest, extraHttpRequestParams?: any): Observable<NewsResource>;

}
